import { useQuery } from '@tanstack/react-query';
import apiClient from '@helpers/apiClientHelper';

interface UseApiQueryOptions {
  endpoint: string;
  headers?: Record<string, string>;
  enabled?: boolean;
  queryKey: unknown[];
  params?: Record<string, number | string>;
  method?: 'GET' | 'POST';
  staleTime?: number;
  gcTime?: number;
}

const getResults = (success: boolean = true, message: string = '', data: any = {}): any => {
  return {
    success,
    message,
    data
  };
};

const useApiQuery = <TData = any>({ endpoint, headers, enabled = true, queryKey, params, method = 'GET', staleTime, gcTime }: UseApiQueryOptions) => {
  return useQuery({
    queryKey,
    queryFn: async () => {
      try {
        const response =
          method === 'POST'
            ? await apiClient.callPost(endpoint, params ?? {}, headers)
            : await apiClient.callGet(endpoint, headers, params ? { params } : undefined);
        if (response.status == 200 && response.data.success) {
          return getResults(true, response?.data?.message, response.data?.result) as TData;
        } else {
          return getResults(false, response?.data?.message, response.data?.result) as TData;
        }
      } catch (error: any) {
        return getResults(false, error?.message || 'Request failed', {}) as TData;
      }
    },
    enabled,
    // refetchOnWindowFocus: false,
    ...(staleTime !== undefined && { staleTime }),
    ...(gcTime !== undefined && { gcTime }),
  });
};

export default useApiQuery;
